import React, { useState, useEffect } from "react";
import Logo from "../components/logo";
import axios from "axios";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import {
  BlockStack,
  Box,
  Button,
  Card,
  InlineStack,
  Page,
  TextField,
} from "@shopify/polaris";
import { Banner } from "@shopify/polaris";

const Login = () => {
  const initalData = {
    email: "",
    password: "",
  };
  const [loginData, setLoginData] = useState(initalData);
  const [loader, setloader] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (value) =>
    setLoginData({ ...loginData, [field]: value });
  useEffect(() => {
    setTimeout(() => {
      setloader(false);
    }, 5000);
  }, [loader]);

  const SignInHandler = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!loginData.email) {
      newErrors.email = "Email is required";
    }

    if (!loginData.password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setloader(true);

    try {
      let data = JSON.stringify(loginData);

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://api.iplanet.one/casaformdata/login",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => response.data)
        .then((response) => {
          if (response.success === true) {
            const token = response.user.token;
            Cookies.set("token", token, { expires: 1, secure: true });
            setLoginData(initalData);
            localStorage.setItem("userEmail", loginData.email);
            // localStorage.setItem("userEmail", email);

            setErrors({});
            window.location.reload();
          } else {
            setErrors({ form: response.message });
          }
        })
        .catch(() => {
          setErrors({ form: "User not found. Please try again." });
        })
        .finally(() => setloader(false));
    } catch (error) {
      setErrors({ form: "Something went wrong" });
      setloader(false);
    }
  };

  return (
    <Page>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          style={{
            minWidth: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100dvh",
          }}
        >
          <Card>
            <Box width="500px">
              <BlockStack gap={300}>
                <InlineStack align="center" gap={200}>
                  <Logo color2="#fff" color1="rgba(12, 74, 110)" />
                </InlineStack>
                <form onSubmit={SignInHandler} style={{ width: "100%" }}>
                  <BlockStack gap="400">
                    {errors.form && (
                      <Banner tone="critical">
                        <p>{errors.form}</p>
                      </Banner>
                    )}
                    <TextField
                      label="Email"
                      type="email"
                      value={loginData.email}
                      onChange={handleChange("email")}
                      autoComplete="email"
                      error={errors.email}
                    />
                    <TextField
                      label="Password"
                      type="password"
                      value={loginData.password}
                      onChange={handleChange("password")}
                      autoComplete="current-password"
                      error={errors.password}
                    />
                    <InlineStack align="end">
                      <Button variant="primary" submit loading={loader}>
                        Sign in
                      </Button>
                    </InlineStack>
                  </BlockStack>
                </form>
              </BlockStack>
            </Box>
          </Card>
        </Box>
      </Box>
    </Page>
  );
};

export default Login;
